import React, { useCallback } from 'react';
import { AddressInfoInput } from '~/components';
import type { StepComponentProps } from '~/components/StepsForm';
import { useIncomeProtectionForm } from '~/stores';

const IncomeProtectionContractAddress: React.FC<StepComponentProps> = ({
  onContinue,
}) => {
  const { setAddress } = useIncomeProtectionForm();

  const onValidate = useCallback(
    (data: IncomeProtectionForm.Address) => {
      setAddress(data);
      onContinue?.();
    },
    [onContinue, setAddress]
  );

  return (
    <AddressInfoInput
      insuranceType="income-protection"
      onValidate={onValidate}
    />
  );
};

export default IncomeProtectionContractAddress;
